import { useCallbackFn } from '@/hooks';
import { DownOutlined } from '@ant-design/icons';
import {
  Button,
  Cascader,
  Checkbox,
  Dropdown,
  Input,
  Menu,
  message,
  Modal,
  Pagination,
  Select,
  Spin,
} from 'antd';
import type { CheckboxChangeEvent } from 'antd/lib/checkbox';
import classNames from 'classnames';
import {
  Close as CloseIcon,
  CubeMaterialColor as CubeMaterialColorIcon,
  Filter as FilterIcon,
  Search as SearchIcon,
  ShaderColor as ShaderColorIcon,
  Site as SiteIcon,
  SmallarrowDown,
  Sort as SortIcon,
  AlertFilled,
} from 'patternx-svg';
import type { ChangeEvent } from 'react';
import { useEffect, useMemo, useRef, useState } from 'react';
import ChangeCategoryModal from './ChangeCategory';
import ChangeAppModal from './ChangeApp';
import EditMaterialModal from './EditMaterialModal';
import Versions from './Version';
import FindEmptyInfo from './FindEmptyInfo';
import EmptyInfo from './ListEmptyInfo';
import MaterialCard from './MaterialCard';
import TagSettingModal from './TagSettingModal';
import UploadMaterialModal from './UploadMaterialModal';
import ViewMaterialModal from './ViewMeterialModal';
import styles from './index.module.less';
import { MaterialContext } from './context';
import searchStore from '../../searchStore';
// import { useDebouncedEffect } from '../element';
import {
  getPhysics,
  getApps,
  getMaterials,
  downMaterial,
  updateMaterialStatus,
  updateMaterialCategory,
  deleteMaterial,
  batchDownMaterial,
  updateMaterialApp,
  getMaterialTags,
  updateMaterialBusinessCategory,
} from '@/services/source';
import { downLoadFile, downLoadFileByBlob } from '@/utils/utils';
import dayjs from 'dayjs';

let dataRefreshTimer: any = null;

const statusOptions = [
  {
    label: '全部',
    value: '',
  },
  {
    label: '上架',
    value: 'osOnline',
  },
  {
    label: '下架',
    value: 'osOffline',
  },
  // {
  //   label: '转换成功',
  //   value: 'transfered',
  // },
  {
    label: '转换中',
    value: 'transfering',
  },
  {
    label: '转换失败',
    value: 'fail',
  },
];

interface MaterialListProps {
  /**
   * 弹窗选择模式
   *  */
  choiceMode?: boolean;
  onChoice?: (materialInfo: Record<string, any> | undefined) => void;
}

const MaterialPage = (props: MaterialListProps) => {
  const { choiceMode = false, onChoice } = props;
  const [showSetting, setShowSetting] = useState(false);
  const [pageObj, setPageObj] = useState({
    page: 1,
    size: 20,
    total: 0,
    totalPage: 0,
  });
  const [materials, setMaterials] = useState<SOURCE.Material[]>([]);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [sortType, setSortType] = useState('updateTime');
  const [isInputSearch, setIsInputSearch] = useState(false);
  const [searchKey, setSearchKey] = useState('');
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [categorys, setCategorys] = useState<any[]>([]);
  const [categoryOptions, setCategoryOptions] = useState<any[]>([]);
  const [appOptions, setAppOptions] = useState<any[]>([]);
  const [selectedCategory, setSelectedCategory] = useState<string[]>([]); //物理属性
  const [selectedApp, setSelectedApp] = useState<any>(undefined);
  const [selectedStatu, setSelectedStatu] = useState<any>(undefined);
  const [selectedCustomCategory, setSelectedCustomCategory] = useState<string[]>([]); //分类
  const [thumbType, setThumbType] = useState('ball');
  const [isEmpty, setIsEmpty] = useState(true);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [currentViewMaterial, setCurrentViewMaterial] = useState<any>({});
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isShowVersions, setIsShowVersions] = useState(false);
  const [currentEditMaterial, setCurrentEditMaterial] = useState<any>({});
  const [isEditCategoryOpen, setIsEditCategoryOpen] = useState(false);
  const [editCategoryIds, setEditCategoryIds] = useState<string[]>([]);
  const [editCategory, setEditCategory] = useState('');
  const [isInitUpload, setIsInitUpload] = useState(false);
  const [isLoadingData, setIsLoadingData] = useState(true);
  const [isEditAppOpen, setIsEditAppOpen] = useState(false);
  const [selectAppList, setSelectAppList] = useState<string[]>([]);

  const searchInputRef = useRef<any>(null);

  const selectedMaterial = useMemo(() => {
    return materials.filter((m) => m._selected);
  }, [materials]);

  const lineText = useMemo(() => {
    const isAllOffline = selectedMaterial?.every((s) => s.onlineStatus === 'osOffline');
    return isAllOffline ? '上架' : '下架';
  }, [selectedMaterial]);

  const filterSelectedCount = useMemo(() => {
    let count = 0;
    if (selectedCategory && selectedCategory.length > 0) {
      count += 1;
    }
    if (selectedApp) {
      count += 1;
    }
    if (selectedStatu) {
      count += 1;
    }
    if (selectedCustomCategory && selectedCustomCategory.length > 0) {
      count += 1;
    }
    return count;
  }, [selectedCategory, selectedApp, selectedStatu, selectedCustomCategory]);

  const toggleShowSetting = () => {
    setShowSetting(!showSetting);
  };

  const fetchMaterials = useCallbackFn(async (page: number, pageSize: number, search = false) => {
    let categoryId = '';
    if (selectedCategory && selectedCategory.length) {
      categoryId = selectedCategory.slice(-1)[0];
    }

    let businessCategoryId = '';
    if (selectedCustomCategory && selectedCustomCategory.length) {
      businessCategoryId = selectedCustomCategory.slice(-1)[0];
    }
    //选中的一级标签,传入所有的2级标签id
    const currentTag = categoryOptions?.find((c) => c?.id === categoryId);
    setIsLoadingData(true);
    const res = await getMaterials({
      page,
      pageSize,
      categoryIds: currentTag
        ? currentTag?.children?.map((c: any) => c?.id)
        : categoryId
        ? [categoryId]
        : [],
      appList: selectedApp ? [selectedApp] : undefined,
      transferStatus: selectedStatu?.includes('line') ? '' : selectedStatu,
      onlineStatus: selectedStatu?.includes('line') ? selectedStatu : '',
      sortType: sortType === 'materialName' ? 1 : 0,
      name: searchKey,
      businessCategoryIds: businessCategoryId ? [businessCategoryId] : [],
    });
    setIsLoadingData(false);
    setPageObj((v) => {
      return {
        ...v,
        page,
        size: pageSize,
      };
    });
    if (res?.success) {
      const mData = res.data.details.list.map((item: any) => {
        return {
          ...item,
          _selected: false,
        };
      });
      setIsEmpty(false);
      if (mData.length === 0 && page === 1 && !search) {
        setIsEmpty(true);
        setIsFilterOpen(false);
      }
      setMaterials(mData);
      setPageObj((v) => {
        return {
          ...v,
          total: res.data.details.page.total,
        };
      });
    }
  });

  const dataRefreshFn = useCallbackFn(() => {
    fetchMaterials(1, pageObj.size, true);
  });

  const startRefreshTimer = () => {
    if (dataRefreshTimer) {
      clearTimeout(dataRefreshTimer);
    }
    dataRefreshTimer = setTimeout(() => {
      dataRefreshFn();
      dataRefreshTimer = null;
    }, 800);
  };
  const fetchCategoryOptions = async () => {
    const res = await getPhysics();
    if (res?.success) {
      setCategoryOptions(
        res.data.details.map((item: any) => {
          return {
            id: item.category,
            value: item.category,
            label: item.category,
            children: item.childs.map((subItem: any) => {
              return {
                id: subItem.materialPhysicsCategoryId,
                value: subItem.materialPhysicsCategoryId,
                label: subItem.category,
              };
            }),
          };
        }),
      );
    }
  };

  const fetchAppOptions = async () => {
    const res = await getApps('app');
    if (res?.success) {
      setAppOptions(
        res.data.details.map((item: any) => {
          return {
            value: item.code,
            label: item.name,
          };
        }),
      );
    }
  };

  const formattree: (arr: any[], res: any[]) => any[] = (arr: any[], res: any[]) => {
    // eslint-disable-next-line no-param-reassign
    res = arr.map((item) => {
      const { id, name, children } = item;
      return {
        ...item,
        label: name,
        value: id,
        children: formattree(children as any[], []),
      };
    });
    return res;
  };

  const fetchCategorys = async () => {
    const res = await getMaterialTags();
    if (res?.success) {
      const details = res?.data?.details?.data || [];
      const arr: any[] = [];
      const datas = formattree(details, arr);
      setCategorys(datas);
    }
  };

  const fetchOptions = async (isRefreshList?: boolean) => {
    await fetchCategorys();
    await fetchCategoryOptions();
    fetchAppOptions();
    let isFiter = false;
    if (Object.keys(searchStore.getMaterial()).length > 0) {
      const tmp = searchStore.getMaterial();
      setSelectedCategory(tmp.type || '');
      setSelectedApp(tmp.app || '');
      setSelectedStatu(tmp.status);
      setSelectedCustomCategory(tmp.category || '');
      if (tmp.type || tmp.app || tmp.status || tmp.category) {
        setIsFilterOpen(true);
        isFiter = true;
      } else {
        isFiter = false;
      }
    }
    if (isRefreshList) {
      setTimeout(() => {
        //是否筛选
        fetchMaterials(1, pageObj.size, isFiter ? true : false);
      }, 100);
    }
  };

  useEffect(() => {
    fetchOptions(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useDebouncedEffect(
  //   () => fetchMaterials(1, 20, false),
  //   [selectedCategory, selectedApp, colorAttrId],
  //   800,
  // );

  const onMaterialSelect = (id: string, select: boolean) => {
    if (choiceMode) {
      if (onChoice) {
        const material = materials.find((m) => m.id === id);
        onChoice(select ? { ...material, thumbType } : undefined);
      }
      setMaterials((v) => {
        return v.map((m) => ({
          ...m,
          _selected: m.id === id && select,
        }));
      });
      return;
    }
    if (select) {
      if (selectedMaterial.length + 1 === materials.length) {
        setIsSelectAll(true);
      } else {
        setIsSelectAll(false);
      }
    } else {
      setIsSelectAll(false);
    }
    setMaterials((v) => {
      return v.map((m) => {
        if (m.id === id) {
          return {
            ...m,
            _selected: select,
          };
        }
        return m;
      });
    });
  };
  const onSelectAllChange = (e: CheckboxChangeEvent) => {
    setIsSelectAll(e.target?.checked);
    if (e.target?.checked) {
      setMaterials((v) => {
        return v.map((m) => {
          return {
            ...m,
            _selected: true,
          };
        });
      });
    } else {
      setMaterials((v) => {
        return v.map((m) => {
          return {
            ...m,
            _selected: false,
          };
        });
      });
    }
  };

  const sortMenu = (
    <Menu
      selectedKeys={[sortType]}
      onClick={(data) => {
        setSortType(data.key);
        startRefreshTimer();
      }}
    >
      <Menu.Item key="updateTime">最近更新</Menu.Item>
      <Menu.Item key="materialName">材质名称A-Z</Menu.Item>
    </Menu>
  );

  /**
   * 搜索框进入和退出逻辑
   */
  const enterInputSearch = () => {
    setIsInputSearch(true);
    setTimeout(() => {
      searchInputRef.current?.focus({
        cursor: 'start',
      });
    }, 100);
  };
  const exitInputSearch = () => {
    if (!searchKey) {
      setIsInputSearch(false);
    }
  };
  const onInputSearchChange = (e: ChangeEvent) => {
    const target: any = e.target;
    const value = target?.value?.trim();
    setSearchKey(value);
    startRefreshTimer();
  };
  /**
   * end - 搜索框进入和退出逻辑
   */
  const onPageChange = (page: number, pageSize: number) => {
    fetchMaterials(page, pageSize, true);
  };

  const onFilterCategoryChange = (category: any) => {
    setSelectedCategory(category);
    searchStore.setMaterial((lib: any) => ({ ...lib, type: category }));
    startRefreshTimer();
  };

  const onFilterCustomCategoryChange = (category: any) => {
    setSelectedCustomCategory(category);
    searchStore.setMaterial((lib: any) => ({ ...lib, category: category }));
    startRefreshTimer();
  };

  const onFilterAppChange = (app: any) => {
    setSelectedApp(app);
    searchStore.setMaterial((lib: any) => ({ ...lib, app }));
    startRefreshTimer();
  };

  const onFilterStatusChange = (status: any) => {
    setSelectedStatu(status);
    searchStore.setMaterial((lib: any) => ({ ...lib, status }));
    startRefreshTimer();
  };

  const thumbMenu = (
    <Menu
      selectedKeys={[thumbType]}
      onClick={(data) => {
        setThumbType(data.key);
      }}
    >
      <Menu.Item key="cube">
        <div className={styles.thumbType}>
          <CubeMaterialColorIcon size={24} />
          <span>立方体</span>
        </div>
      </Menu.Item>
      <Menu.Item key="ball">
        <div className={styles.thumbType}>
          <ShaderColorIcon size={24} />
          <span>材质球</span>
        </div>
      </Menu.Item>
    </Menu>
  );
  const onUploadClose = () => {
    setIsUploadModalOpen(false);
  };
  // 上传结束，刷新
  const onUploadFinish = () => {
    if (isInitUpload) {
      fetchMaterials(pageObj.page, pageObj.size);
    } else {
      fetchMaterials(pageObj.page, pageObj.size);
    }
  };

  const onMaterialView = async (material: SOURCE.Material) => {
    setCurrentViewMaterial(material);
    setIsViewModalOpen(true);
  };

  const onMaterialEdit = async (material: SOURCE.Material) => {
    setCurrentEditMaterial(material);
    setIsEditModalOpen(true);
  };

  const onShowVersions = async (material: SOURCE.Material) => {
    setCurrentEditMaterial(material);
    setIsShowVersions(true);
  };

  // const onMaterialDelete = async (material: SOURCE.Material) => {
  //   console.log(material);

  //   const page = materials.length === 1 ? pageObj.page - 1 : pageObj.page;

  //   fetchMaterials(page < 1 ? 1 : page, pageObj.size);
  // };
  const onEditClose = () => {
    setIsEditModalOpen(false);
  };

  const onRefreshData = useCallbackFn((isRequestPrev?: boolean) => {
    let currentPage = pageObj.page;
    if (isRequestPrev) {
      currentPage = currentPage - 1 < 1 ? 1 : currentPage - 1;
    }
    //是否筛选或者搜索
    const isFiterOrSearch = filterSelectedCount > 0 || searchKey;
    fetchMaterials(currentPage, pageObj.size, isFiterOrSearch ? true : false);
  });

  const onDelete = async (ids: string[]) => {
    Modal.confirm({
      title: `是否删除已选材质 ？`,
      content: `删除材质后无法恢复。`,
      okText: '删除',
      okButtonProps: {
        type: 'primary',
        danger: true,
      },
      style: { top: '30%' },
      icon: <AlertFilled size={24} className={classNames('anticon', styles.alertIcon)} />,
      // centered: true,
      cancelText: '取消',
      onOk: async () => {
        const res = await deleteMaterial(ids);
        if (res?.success) {
          message.success('材质已删除');
          const isRequestPrev = materials?.length === ids?.length;
          onRefreshData(isRequestPrev);
          setIsViewModalOpen(false);
        }
      },
      onCancel() {},
    });
  };

  const onBatchDelete = async () => {
    const mIds = selectedMaterial.map((m) => m.id);
    onDelete(mIds);
  };

  const onCategoryChange = async (ids: string[], categoryId: string) => {
    // TODO:
    // console.log(ids, '====categoryId', categoryId);
    const res = await updateMaterialBusinessCategory({
      businessCategoryIds: [categoryId],
      materialIds: ids,
    });
    if (res?.success) {
      message.success('分类信息已修改');
      setIsEditCategoryOpen(false);
      onRefreshData();
    }
  };
  const onBatchCategoryChange = () => {
    const ids = selectedMaterial.map((m) => m?.id || '');
    setEditCategoryIds(ids);
    setEditCategory('');
    setIsEditCategoryOpen(true);
  };
  const onSingleCategoryChange = (id: string, categoryId: string) => {
    const ids = [id];
    setEditCategoryIds(ids);
    setEditCategory(categoryId);
    setIsEditCategoryOpen(true);
  };

  const onBatchAppChange = async () => {
    setSelectAppList([]);
    setIsEditAppOpen(true);
  };

  const onAppChange = async (apps: string[]) => {
    const ids = selectedMaterial.map((m) => m?.currentVersionId || '');
    const res = await updateMaterialApp({ appList: apps, materialVersionIds: ids });
    if (res?.success) {
      message.success('应用已修改');
      setIsEditAppOpen(false);
      onRefreshData();
    }
  };

  const onBatchDownload = async () => {
    const params = selectedMaterial.map((m) => {
      return {
        storageFileId: m.sourceFileId || '',
        name: m.name,
      };
    });
    const res = await batchDownMaterial(params);
    if (res?.data) {
      const zipName = `材质批量打包_${dayjs().format('HH:mm')?.replace(':', '')}.zip`;
      downLoadFileByBlob(res.data, zipName);
    }
  };

  const onSingleDownLoad = async (row: any, from?: string) => {
    let fileName = row?.name;
    if (from === 'version') {
      fileName = row?.name?.slice(0, row?.name?.lastIndexOf('.'));
    }
    const res = await downMaterial(row?.downloadStorageFileId, fileName);
    if (res?.data?.details?.downloadUrl) {
      downLoadFile(res?.data?.details?.downloadUrl, fileName);
    }
  };

  const updataHanlde = async (status: string, text: string, ids: string[]) => {
    const res = await updateMaterialStatus(status, ids);
    if (res?.success) {
      message.success(text);
      onRefreshData();
    }
  };

  const onUpdateStatus = async (status: string, text: string, ids: string[]) => {
    if (status === 'osOffline') {
      Modal.confirm({
        title: `是否下架已选材质 ？`,
        content: `下架后，相关应用将无法调用材质，已使用的材质不受影响`,
        okText: '下架',
        okButtonProps: {
          type: 'primary',
          danger: true,
        },
        style: { top: '30%' },
        icon: <AlertFilled size={24} className={classNames('anticon', styles.alertIcon)} />,
        // centered: true,
        cancelText: '取消',
        onOk: async () => {
          updataHanlde(status, text, ids);
        },
        onCancel() {},
      });
    } else {
      updataHanlde(status, text, ids);
    }
  };

  const onBatchUpdateStatus = () => {
    const mIds = selectedMaterial.map((m) => m.id);
    if (lineText === '上架') {
      updataHanlde('osOnline', '材质已上架', mIds);
    } else {
      onUpdateStatus('osOffline', '材质已下架', mIds);
    }
  };

  const onCloseTagModal = useCallbackFn((isRefresh?: boolean) => {
    setShowSetting(false);
    //TODO  请求分类
    fetchCategorys();
    if (isRefresh) {
      //是否筛选或者搜索
      const isFiterOrSearch = filterSelectedCount > 0 || searchKey;
      fetchMaterials(1, pageObj.size, isFiterOrSearch ? true : false);
    }
  });

  return (
    <MaterialContext.Provider value={{ propertyName: '属性' }}>
      <div className={styles.pageWrap}>
        <div className={styles.header}>
          <div className={styles.left}>
            {!isEmpty && (
              <>
                <div className={styles.displayType}>
                  <Dropdown overlay={thumbMenu} overlayClassName={styles.dropdown}>
                    {thumbType === 'cube' ? (
                      <div className={styles.thumbType}>
                        <CubeMaterialColorIcon size={24} />
                        <span>立方体</span>
                        <DownOutlined style={{ marginLeft: 8 }} />
                      </div>
                    ) : (
                      <div className={styles.thumbType}>
                        <ShaderColorIcon size={24} />
                        <span>材质球</span>
                        <DownOutlined style={{ marginLeft: 8 }} />
                      </div>
                    )}
                  </Dropdown>
                </div>
                <div className={styles.divider} />
              </>
            )}
            <div className={styles.functions}>
              {!isEmpty && (
                <>
                  <div
                    className={`${styles.fn} ${styles.filter} ${
                      isFilterOpen ? styles.active : ''
                    } ${filterSelectedCount > 0 ? styles.forceColor : ''}`}
                    onClick={() => setIsFilterOpen((v) => !v)}
                  >
                    <FilterIcon size={20} />
                    {filterSelectedCount > 0 && (
                      <>
                        <span style={{ fontSize: 14, marginLeft: 6 }}>{filterSelectedCount}</span>
                        <CloseIcon
                          size={15}
                          onClick={() => {
                            setSelectedCategory([]);
                            setSelectedCustomCategory([]);
                            setSelectedStatu(undefined);
                            setSelectedApp(undefined);
                            startRefreshTimer();
                          }}
                          style={{ verticalAlign: 'middle', marginLeft: 12, color: '#5F6173' }}
                        />
                      </>
                    )}
                  </div>
                  <div className={`${styles.fn}`}>
                    <Dropdown overlay={sortMenu}>
                      <div className={styles.order}>
                        <SortIcon size={20} />
                        <span style={{ fontSize: 12, marginLeft: 8 }}>
                          {sortType === 'updateTime' ? '最近更新' : '材质名称A-Z'}
                        </span>
                      </div>
                    </Dropdown>
                  </div>
                </>
              )}
              <div className={`${styles.fn} ${styles.setting}`} onClick={toggleShowSetting}>
                <SiteIcon size={20} />
              </div>
            </div>
          </div>
          <div className={styles.right}>
            {!isEmpty && (
              <div className={styles.search} style={{ marginRight: 12 }}>
                {isInputSearch ? (
                  <Input
                    size="middle"
                    ref={searchInputRef}
                    value={searchKey}
                    prefix={<SearchIcon size={14} style={{ display: 'block' }} />}
                    placeholder="搜索材质名称"
                    onBlur={exitInputSearch}
                    onChange={onInputSearchChange}
                    allowClear
                  />
                ) : (
                  <SearchIcon
                    size={20}
                    style={{ display: 'block', cursor: 'pointer' }}
                    onClick={enterInputSearch}
                  />
                )}
              </div>
            )}
            {selectedMaterial.length > 0 && !choiceMode ? (
              <div className={styles.batchOp}>
                <Button type="default" danger style={{ marginRight: 12 }} onClick={onBatchDelete}>
                  删除
                </Button>
                <Button type="default" style={{ marginRight: 12 }} onClick={onBatchUpdateStatus}>
                  {lineText}
                </Button>
                <Button type="default" style={{ marginRight: 12 }} onClick={onBatchDownload}>
                  下载
                </Button>
                <Button type="default" style={{ marginRight: 12 }} onClick={onBatchAppChange}>
                  修改应用
                </Button>
                <Button type="default" onClick={onBatchCategoryChange}>
                  修改分类
                </Button>
              </div>
            ) : null}

            {selectedMaterial.length > 0 ? <div className={styles.divider} /> : null}

            {!isEmpty && !choiceMode && (
              <Button
                type="primary"
                onClick={() => {
                  setIsInitUpload(false);
                  setIsUploadModalOpen(true);
                }}
              >
                新增材质
              </Button>
            )}
          </div>
        </div>
        {isFilterOpen ? (
          <div className={styles.filterData}>
            <div className={styles.flex1}>
              <div className={styles.subTitle}>分类</div>
              <Cascader
                changeOnSelect
                expandTrigger="hover"
                bordered={false}
                options={categorys}
                placeholder="全部"
                style={{ minWidth: 80, width: 'auto' }}
                onChange={onFilterCustomCategoryChange}
                suffixIcon={<SmallarrowDown size={16} />}
                value={selectedCustomCategory}
              />
            </div>
            <div className={styles.flex1}>
              <div className={styles.subTitle}>物理属性</div>
              <Cascader
                changeOnSelect
                expandTrigger="hover"
                bordered={false}
                options={categoryOptions}
                placeholder="全部"
                style={{ minWidth: 80, width: 'auto' }}
                onChange={onFilterCategoryChange}
                suffixIcon={<SmallarrowDown size={16} />}
                value={selectedCategory}
              />
            </div>
            <div className={styles.flex1}>
              <div className={styles.subTitle}>应用</div>
              <Select
                // mode="multiple"
                options={[
                  {
                    label: '全部',
                    value: '',
                  },
                  ...appOptions,
                ]}
                bordered={false}
                style={{ minWidth: 100 }}
                placeholder="全部"
                showArrow
                // allowClear
                suffixIcon={<SmallarrowDown size={16} />}
                onChange={onFilterAppChange}
                value={selectedApp}
              />
            </div>
            <div className={styles.flex1}>
              <div className={styles.subTitle}>状态</div>
              <Select
                // mode="multiple"
                // allowClear
                options={statusOptions}
                bordered={false}
                style={{ minWidth: 80 }}
                placeholder="全部"
                showArrow
                suffixIcon={<SmallarrowDown size={16} />}
                onChange={onFilterStatusChange}
                value={selectedStatu}
              />
            </div>
          </div>
        ) : null}
        <div className={styles.content}>
          <Spin spinning={isLoadingData} className={styles.spinWrap}>
            {isEmpty ? ( // 页面没有数据
              <div className={styles.wrap}>
                <EmptyInfo
                  onCreate={() => {
                    setIsInitUpload(true);
                    setIsUploadModalOpen(true);
                  }}
                />
              </div>
            ) : (
              <div className={styles.wrap}>
                {materials.length === 0 ? ( // 当前页没有数据
                  <div className={styles.list}>
                    <FindEmptyInfo title="没有找到相关结果" desc="请更换关键词" />
                  </div>
                ) : (
                  <div className={styles.list}>
                    {!choiceMode && (
                      <div className={styles.selectAll}>
                        {selectedMaterial.length > 0 && (
                          <>
                            <Checkbox onChange={onSelectAllChange} checked={isSelectAll}>
                              全选
                            </Checkbox>
                            <span className={styles.number}>
                              已选择{' '}
                              <span style={{ color: 'var(--patternx-brand-6)' }}>
                                {selectedMaterial.length}
                              </span>{' '}
                              项
                            </span>
                          </>
                        )}
                      </div>
                    )}
                    <div className={classNames(styles.cardList, choiceMode && styles.smaller)}>
                      {materials.map((m: SOURCE.Material) => {
                        return (
                          <div key={m.id} className={styles.material}>
                            <MaterialCard
                              checkForce={selectedMaterial.length > 0}
                              title={m.name}
                              thumbType={thumbType}
                              material={m}
                              choiceMode={choiceMode}
                              onSelectChange={(s: boolean) => {
                                onMaterialSelect(m.id, s);
                              }}
                              onView={() => {
                                onMaterialView(m);
                              }}
                              onEdit={() => {
                                onMaterialEdit(m);
                              }}
                              onVersion={() => {
                                onShowVersions(m);
                              }}
                              // onDelete={(success) => {
                              //   if (success) {
                              //     onMaterialDelete(m);
                              //   }
                              // }}
                              onDelete={() => {
                                onDelete([m.id]);
                              }}
                              // onCategoryChange={() => {
                              //   onSingleCategoryChange(m?.currentVersionId || '', m.categoryId);
                              // }}
                              onDownload={() => {
                                onSingleDownLoad({
                                  ...m,
                                  downloadStorageFileId: m.sourceFileId,
                                });
                              }}
                              onUpdateSatus={() => {
                                const status =
                                  m?.onlineStatus === 'osOnline' ? 'osOffline' : 'osOnline';
                                const text =
                                  m?.onlineStatus === 'osOnline' ? '材质已下架' : '材质已上架';
                                onUpdateStatus(status, text, [m.id]);
                              }}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
                <div className={styles.footer}>
                  <span style={{ color: 'rgba(0, 0, 0, 0.45)' }}>共{pageObj.total}条</span>
                  <Pagination
                    showQuickJumper
                    showSizeChanger
                    current={pageObj.page}
                    pageSize={pageObj.size}
                    total={pageObj.total}
                    onChange={onPageChange}
                  />
                </div>
              </div>
            )}
          </Spin>
        </div>
        {showSetting ? <TagSettingModal onClose={onCloseTagModal} /> : null}
        {isUploadModalOpen ? (
          <UploadMaterialModal
            categoryOptions={categoryOptions}
            onClose={onUploadClose}
            onFinish={onUploadFinish}
            appOptions={appOptions}
            businessCategorys={categorys}
          />
        ) : null}
        {isViewModalOpen ? (
          <ViewMaterialModal
            info={currentViewMaterial ?? {}}
            defaultThumbType={thumbType}
            onEdit={() => {
              setIsViewModalOpen(false);
              onMaterialEdit(currentViewMaterial);
            }}
            onDelete={onDelete}
            onClose={() => setIsViewModalOpen(false)}
            appOption={appOptions}
            showVersion={(m: any) => {
              setIsViewModalOpen(false);
              onShowVersions(m);
            }}
            refresh={onRefreshData}
            categorys={categorys}
          />
        ) : null}
        {isEditModalOpen ? (
          <EditMaterialModal
            info={currentEditMaterial}
            categoryOptions={categoryOptions}
            onClose={onEditClose}
            onUpdate={onRefreshData}
            appOptions={appOptions}
            businessCategorys={categorys}
          />
        ) : null}

        {isShowVersions ? (
          <Versions
            data={currentEditMaterial}
            // view={(m: any) => {
            //   onMaterialView(m);
            //   setIsShowVersions(false);
            // }}
            visible={isShowVersions}
            onCancel={() => setIsShowVersions(false)}
            init={startRefreshTimer}
            onDown={onSingleDownLoad}
          />
        ) : null}

        {isEditCategoryOpen ? (
          <ChangeCategoryModal
            ids={editCategoryIds}
            selectCategoryId={editCategory}
            categoryOptions={categorys}
            onChange={onCategoryChange}
            onClose={() => setIsEditCategoryOpen(false)}
          />
        ) : null}

        {isEditAppOpen ? (
          <ChangeAppModal
            selectAppList={selectAppList}
            appOptions={appOptions}
            onChange={onAppChange}
            onClose={() => setIsEditAppOpen(false)}
          />
        ) : null}
      </div>
    </MaterialContext.Provider>
  );
};

export default MaterialPage;
